<template>
  <div class="privacy-policy">
    <!-- Hero Banner -->
    <section class="hero-banner" style="background-color: #171f39;">
      <div class="container">
        <h1 style="color: white;">Privacy Policy</h1>
      </div>
    </section>

    <!-- Main Content -->
    <div class="container content-container">
      <div class="policy-content">
        <p>This privacy policy explains how we collect, use, and protect your personal information.</p>
        
        <h2>Information We Collect</h2>
        <p>We collect information you provide directly to us, such as your name, email address, and phone number when you create an account or subscribe to our newsletter. We may also automatically collect certain data, including your IP address, browser type, and access times, to improve our services and analyze usage.</p>
        
        <h2>How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide and maintain our services.</li>
          <li>Improve and personalize your experience.</li>
          <li>Send you updates, newsletters, and promotional materials.</li>
          <li>Respond to your inquiries and offer customer support.</li>
        </ul>
        
        <h2>Information Sharing</h2>
        <p>We do not sell, trade, or rent your personal information to third parties. We may share your data with trusted service providers who assist us in operating our business, but only to the extent necessary to perform their functions. We may also disclose your information if required by law.</p>
        
        <h2>Data Security</h2>
        <p>We implement various security measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.</p>
        
        <h2>Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. You can also opt out of receiving promotional communications from us at any time.</p>
        
        <h2>Changes to This Policy</h2>
        <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
      </div>
    </div>
    
    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-social" style="order: -1; justify-content: flex-start; text-align: left;">
          <div class="social-title">Follow us!</div>
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/advancedinnovaticssolutions/about/?viewAsMember=true" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
              <span>in</span>
            </a>
          </div>
        </div>
        <div class="cta-content" style="order: 1;">
          <h2>Ready to transform your business?</h2>
          <router-link to="/contact" class="btn btn-white">Let's connect</router-link>
          <div class="cta-quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="cta-footer">Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo: {
    title: 'Privacy Policy | Your Company Name',
    meta: [
      { name: 'description', content: 'Learn how we collect, use, and protect your personal information.' }
    ]
  }
}
</script>

<style scoped>
/* Hero Banner Styles */
.hero-banner {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: white;
  padding: 5rem 0;
  text-align: center;
  margin-bottom: 3rem;
}

.hero-banner h1 {
  font-size: 2.5rem;
  margin: 0 auto 1rem;
  font-weight: 700;
  max-width: 800px;
  line-height: 1.3;
}

.hero-banner p {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Content Styles */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.content-container {
  padding: 0 2rem 4rem;
}

.policy-content {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
  color: #333;
}

h2 {
  color: #2c3e50;
  margin: 2.5rem 0 1rem;
  font-size: 1.75rem;
  font-weight: 600;
}

p {
  margin-bottom: 1.25rem;
  font-size: 1.05rem;
}

ul {
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

/* CTA Section */
.cta {
  background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
  color: white;
  text-align: left;
  padding: 6rem 0;
  margin-top: 4rem;
}

.cta .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.cta .cta-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
  order: 1;
  text-align: right;
}

.cta .cta-content .cta-footer {
  flex: 0 0 100%;
  text-align: left;
  margin-top: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
}

.cta h2 {
  color: #ffffff;
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
}

.cta .cta-social {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  text-align: left;
  order: -1;
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
  margin: 0;
}

.cta .cta-social .social-icons {
  display: flex;
  gap: 1rem;
}

.cta .cta-social .social-icon {
  width: 64px;
  height: 64px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  font-size: 1.5rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: 700;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-quick-links {
  margin: 2rem 0;
  text-align: left;
}

.cta .cta-quick-links h3 {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cta .cta-quick-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
}

.cta .cta-quick-links a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s ease;
}

.cta .cta-quick-links a:hover {
  color: white;
  text-decoration: underline;
}

.cta .btn-white {
  background: transparent;
  color: #ffffff;
  border: 3px solid #ffffff;
  border-radius: 50px;
  padding: 0.75rem 2.5rem;
  font-weight: 700;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
  display: inline-block;
  letter-spacing: 0.5px;
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 992px) {
  .cta .container {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
  
  .cta .cta-content {
    order: 2;
    text-align: left;
    width: 100%;
  }
  
  .cta .cta-social {
    order: 1;
    margin-bottom: 1rem;
  }
  
  .cta h2 {
    font-size: 2rem;
  }
  
  .cta .cta-content .cta-footer {
    text-align: left;
  }
}

.cta-footer {
  margin-top: 1rem;
  font-size: 0.9rem;
  opacity: 0.8;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-banner {
    padding: 3rem 0;
  }
  
  .hero-banner h1 {
    font-size: 2rem;
  }
  
  .content-container {
    padding: 0 1rem 3rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .hero-banner h1 {
    font-size: 1.75rem;
  }
  
  .hero-banner p {
    font-size: 1rem;
  }
  
  p, li {
    font-size: 1rem;
  }
}
</style>
